import React from 'react';
import MyNavbar from '../Home/MyNavbar/MyNavbar';

const Blogs = () => {
    return (
        <>
        <MyNavbar></MyNavbar>
        <div className="App">
            <h1 className="text-white align-content-center mt-5 pt-5">Blogs Coming Soon!!!!!!</h1>
        </div>
        </>
    );
};

export default Blogs;